import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useParams, useSearchParams } from 'react-router-dom';
import { postMAGAC030, postMAGAC030Excel, postMAGAC030DeleteComment } from '../../../services/Api';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MENUS } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas } from '../../../utils';
import Loader from '../../../shared/components/Loader';
registerLocale('ko', ko);

const MAGAC030 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const [data, setData] = useState([]);
    const [searchCondition, setSearchCondition] = useState('MemberID');
    const [keyword, setKeyword] = useState('');
    const [dateRate, setDateRate] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [loading, setLoading] = useState(false);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const { id } = useParams();

    const getSearchCondition = (e) => {
        const selectedValue = e.target.value;
        setSearchCondition(selectedValue);
    };

    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name) => {
        setDateRate('');
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const getListData = (currentPage = page) => {
        const startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postMAGAC030(id, {
            page: currentPage,
            searchCondition,
            keyword: keyword?.trim(),
            startDate: startDateFormated,
            endDate: endDateFormated,
        })
            .then(({ data }) => {
                setData(Array.isArray(data?.data) ? data.data : []);
                setPages(data?.info || {});
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };
    const clickReset = () => {
        setSearchParams('');
        setSearchCondition('MemberID');
        setKeyword('');
        setDateRate('');
        setStartDate('');
        setEndDate('');
    };

    const handleDownload = (typeDownload) => {
        postMAGAC030Excel(id, typeDownload)
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `이벤트_결과.${typeDownload}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    const handleDelete = (seq) => {
        if (window.confirm('댓글을 삭제하시겠습니까?')) {
            postMAGAC030DeleteComment(seq)
                .then(() => {
                    alert('댓글이 삭제되었습니다.');
                    getListData(page);
                })
                .catch((error) => {
                    console.error(error);
                    alert('댓글 삭제 중 오류가 발생했습니다.');
                });
        }
    };

    useEffect(() => {
        getListData(page);
        // eslint-disable-next-line
    }, [page]);

    const flatData = data.flatMap((item, idx) => [
        { ...item, parentIndex: null, rowIndex: idx },
        ...(item.replies || []).map(reply => ({ ...reply, parentIndex: idx, rowIndex: idx }))
    ]);

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_MENUS} />
                <div className="content-right magac030">
                    <h1 className="title">이벤트</h1>
                    <div id="search-box">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>교육명 검색</th>
                                    <td>
                                        <div className="select-box">
                                            <select onChange={getSearchCondition} value={searchCondition}>
                                                <option value="MemberID">모집기간명</option>
                                                <option value="NameKor">지역</option>
                                            </select>
                                            <input
                                                type="text"
                                                placeholder="검색어 입력"
                                                onChange={inputChange}
                                                value={keyword}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>등록일</th>
                                    <td colSpan={3}>
                                        <div className="flex group-item">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={startDateRef}
                                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={startDate}
                                                        maxDate={endDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => startDateRef.current.setFocus()}
                                                    />
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={endDateRef}
                                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={endDate}
                                                        minDate={startDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="end-date-icon"
                                                        onClick={() => endDateRef.current.setFocus()}
                                                    />
                                                </div>
                                            </div>
                                            <ul className="select-value">
                                                <li
                                                    value-date-range="today"
                                                    className={dateRate === 'today' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    오늘
                                                </li>
                                                <li
                                                    value-date-range="1week"
                                                    className={dateRate === '1week' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    일주일
                                                </li>
                                                <li
                                                    value-date-range="15days"
                                                    className={dateRate === '15days' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    15일
                                                </li>
                                                <li
                                                    value-date-range="1month"
                                                    className={dateRate === '1month' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    1개월
                                                </li>
                                                <li
                                                    value-date-range="3months"
                                                    className={dateRate === '3months' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    3개월
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="group-button center">
                            <button className="btn btn-gray-bold" onClick={clickSearch}>
                                검색
                            </button>
                            <button className="btn btn-gray-thin" onClick={clickReset}>
                                초기화
                            </button>
                        </div>
                    </div>

                    <div className="button-item">
                        <button onClick={() => handleDownload('xlsx')} disabled={loading}>
                            {loading ? <Loader /> : '엑셀 다운로드'}
                        </button>
                    </div>
                    <div className="result">
                        <div className="count-item">
                            총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                        </div>
                        <div className="table-wrap">
                            <table className="table table-gray">
                                <thead>
                                    <tr>
                                        <th>삭제</th>
                                        <th>댓글번호</th>
                                        <th>댓글 구분</th>
                                        <th>구분</th>
                                        <th>회원ID</th>
                                        <th>이름</th>
                                        <th>DVmall 맴버십 여부</th>
                                        <th>근무처명</th>
                                        <th>회원구분</th>
                                        <th>면허번호</th>
                                        <th>Email</th>
                                        <th>연략처</th>
                                        <th>핸드폰</th>
                                        <td>주소</td>
                                        <th style={{ width: '300px' }}>내용</th>
                                        <th>좋아요</th>
                                        <th>선택 사은품</th>
                                        <th>등록일</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {flatData.length > 0 ? (
                                        flatData.map((item) => (
                                            <tr key={item.seq}>
                                                <td>
                                                    <span style={{ color: '#dc3545', cursor: 'pointer' }} onClick={() => handleDelete(item.seq)}>삭제</span>
                                                </td>
                                                <td>{pages.totalRow - ((pages.page - 1) * pages.size) - item.rowIndex}</td>
                                                <td>{item?.parentSeq == null ? '댓글' : '대댓글'}</td>
                                                <td>{item?.memberGbn === 'C' ? '치과' : '개인'}</td>
                                                <td>{item?.memberId}</td>
                                                <td>{item?.nameKor}</td>
                                                <td>{item?.emJoinMembership === 0 ? '비회원' : '회원'}</td>
                                                <td>{item?.bizCompany}</td>
                                                <td>{item?.appGbnNm}</td>
                                                <td>{item?.licenseNo}</td>
                                                <td>{item?.email}</td>
                                                <td>{item?.telNo}</td>
                                                <td>{item?.mobileNo}</td>
                                                <td>{item?.address}</td>
                                                <td style={{ minWidth: '500px' }}>{item?.review}</td>
                                                <td>{item?.likeCnt}</td>
                                                <td>{item?.giftName}</td>
                                                <td>{formatDate(item?.addDate)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={15}>데이타가 없습니다.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAGAC030;
